/* eslint-disable no-shadow */
/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

/* eslint-disable default-case */
/* eslint-disable quotes */
import _ from 'lodash';
import Vue from 'vue';

import Vuetify from '@/plugins/vuetify';
import AssetCollection from '@/classes/AssetCollection';
import { getOptions } from '@/classes/api';

const DEBUG = false;

const STUB_IMAGES = {
  'logo-image': require('@/assets/logo.png'),
  'background-image': require('@/assets/back.png'),
  'system-avatar': require('@/assets/app-avatar.png'),
  'user-avatar': require('@/assets/user-avatar.svg'),
  'send-button': require('@/assets/paper-plane.svg'),
  'logout-button': require('@/assets/sign-out-alt.svg'),
};

function getPaletteHash(elements) {
  const hash = _.reduce(
    elements || [],
    (memo, item) => {
      if (!memo[item.name]) {
        memo[item.name] = item.value;
      } else {
        if (memo[item.name].realm != 'all') {
          memo[item.name] = item.value;
        }
      }

      return memo;
    },
    {}
  );

  return hash;
}

function updateTheme(state) {
  let buf = _.filter(state.elements || [], item => item.type === 'color');

  if (buf.length) {
    Vuetify.framework.theme.themes.light = _.extend(state.theme, getPaletteHash(buf || []));
  }
}

// initial state
const state = {
  elements: [],

  theme: null,

  initialFetchComplete: false,
};

// getters
const getters = {
  logoImage(state, getters) {
    return getters.universalImage('logo-image');
  },
  backgroundImage(state, getters) {
    return getters.universalImage('background-image');
  },
  systemAvatar(state, getters) {
    return getters.universalImage('system-avatar');
  },
  userAvatar(state, getters) {
    return getters.universalImage('user-avatar');
  },
  universalImage: state => imageName => {
    const uImage = _.find(state.elements || [], { name: imageName, type: 'image' });

    if (uImage && uImage.value) {
      return getOptions().domain + uImage.value;
    } else {
      return STUB_IMAGES[imageName];
    }
  },
};

// actions
const actions = {
  ...AssetCollection.actions,

  async fetch({ dispatch, commit, state }) {
    if (!state.theme) commit('backupTheme', Vuetify.framework.theme.themes.light || {});

    try {
      let result = await dispatch('find', {
        filter: {
          where: {
            realm: {
              inq: ['all', 'built-in-chat'],
            },
          },
        },
      });
      if (!state.initialFetchComplete) commit('setInitialState', true);
      return result;
    } catch (e) {
      console.log('theme (line : 75) | fetch | e : ', e);
      if (!state.initialFetchComplete) commit('setInitialState', true);
      throw e;
    }
  },
};

// mutations
const mutations = {
  addElement(state, element) {
    const buf = element && element.data ? element.data : element;
    state.elements = [...state.elements, buf];

    updateTheme(state);
  },
  setElement(state, element) {
    const buf = element && element.data ? element.data : element;
    let index = _.findIndex(state.elements || [], { id: buf.id });

    if (index < 0) {
      state.elements.push(buf);
    } else {
      Vue.set(state.elements, index, buf);
    }

    updateTheme(state);
  },
  deleteElement(state, id) {
    let index = _.findIndex(state.elements, { id });
    if (index > 0) state.elements.splice(index, 1);

    updateTheme(state);
  },

  setElements(state, elements) {
    state.elements = elements && elements.data ? elements.data : elements;

    state.initialFetchComplete = true;
    updateTheme(state);
  },
  setInitialState(state, data) {
    state.initialFetchComplete = data;
  },
  backupTheme(state, data) {
    state.theme = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
